import { useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { subscriptionService } from 'services';

export const usePrefetchSubscriptionDetail = () => {
  const queryClient = useQueryClient();
  return (id: number) => {
    queryClient.prefetchQuery(
      [ServerStateKeysEnum.subscriptionDetail, id],
      () => subscriptionService.subscriptionDetail(id),
      { staleTime: 5 * 60 * 1000 } // 5 minutes
    );
  };
};
